import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  useMediaQuery,
  useTheme,
} from "@mui/material";

const WhatsAppDialog = ({
  open,
  onClose,
  whatsappNumbers,
  orderId,
  customerData,
  onSendToWhatsApp,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleSend = (whatsappLink) => {
    if (!orderId) return;

    // الحصول على التاريخ والوقت الحالي
    const now = new Date();
    const dateStr = now.toLocaleDateString("ar-EG", {
      year: "numeric",
      month: "long",
      day: "numeric",
      weekday: "long",
    });
    const timeStr = now.toLocaleTimeString("ar-EG", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    // إنشاء رسالة الطلب مع التاريخ والوقت
    const message = encodeURIComponent(
      `🛒 *طلب جديد رقم: ${orderId}*\n\n` +
        `📅 *التاريخ:* ${dateStr}\n` +
        `⏰ *الوقت:* ${timeStr}\n\n` +
        `👤 *بيانات العميل:*\n` +
        `رقم الطاولة: ${customerData?.customer_name || "غير محدد"}\n\n` +
        `شكراً لكم 🌟`
    );

    // استخدام الرابط مباشرة من البيانات المستلمة
    const whatsappUrl = `${whatsappLink.link}?text=${message}`;

    // فتح واتساب في تبويب جديد
    window.open(whatsappUrl, "_blank", "noopener,noreferrer");

    // استدعاء callback للإغلاق والتنظيف
    if (onSendToWhatsApp) {
      onSendToWhatsApp();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      fullScreen={isMobile}
      PaperProps={{
        sx: {
          borderRadius: { xs: 0, sm: 6 },
          bgcolor: "#fff",
          boxShadow: "0 12px 48px 0 rgba(37, 211, 102, 0.18)",
          p: 0,
          border: { xs: 0, sm: "2px solid #25D366" },
          m: { xs: 0, sm: 2 },
        },
      }}
    >
      <DialogTitle
        sx={{
          fontWeight: "bold",
          color: "#25D366",
          textAlign: "center",
          fontSize: { xs: 20, sm: 24 },
          letterSpacing: 1,
          bgcolor: "#fff",
          pt: { xs: 3, sm: 3 },
          px: { xs: 2, sm: 3 },
          pb: 1,
        }}
      >
        هل تريد إرسال الطلب عبر واتساب؟
      </DialogTitle>
      <DialogContent sx={{ pt: 2, pb: 2, px: { xs: 2, sm: 3 } }}>
        <Typography
          sx={{
            color: "#666",
            fontWeight: 500,
            fontSize: { xs: 14, sm: 16 },
            textAlign: "center",
            mb: 3,
            lineHeight: 1.6,
          }}
        >
          يمكنك إرسال تفاصيل طلبك مباشرة عبر واتساب للتأكيد السريع
        </Typography>

        {whatsappNumbers.length > 0 ? (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
            {whatsappNumbers.map((whatsapp) => (
              <Button
                key={whatsapp.id}
                onClick={() => handleSend(whatsapp)}
                variant="contained"
                fullWidth
                sx={{
                  bgcolor: "#25D366",
                  color: "#fff",
                  fontWeight: 700,
                  fontSize: { xs: 14, sm: 15 },
                  py: 1.5,
                  borderRadius: 2,
                  "&:hover": { bgcolor: "#128C7E" },
                  boxShadow: "0 2px 8px #25D36633",
                }}
              >
                📱 {whatsapp.name_ar}
              </Button>
            ))}
          </Box>
        ) : (
          <Typography
            sx={{
              color: "#999",
              textAlign: "center",
              fontSize: { xs: 13, sm: 14 },
            }}
          >
            لا توجد أرقام واتساب متاحة
          </Typography>
        )}
      </DialogContent>
      <DialogActions
        sx={{
          px: { xs: 2, sm: 3 },
          pb: { xs: 2, sm: 2 },
          pt: 0,
          bgcolor: "#fff",
          justifyContent: "center",
        }}
      >
        <Button
          onClick={onClose}
          color="secondary"
          fullWidth
          size="large"
          sx={{
            fontWeight: 700,
            borderRadius: 2,
            bgcolor: "#eee",
            color: "#666",
            px: 4,
            py: { xs: 1.2, sm: 1 },
            fontSize: { xs: 14, sm: 15 },
            "&:hover": { bgcolor: "#ddd" },
          }}
        >
          تخطي
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WhatsAppDialog;
